import React from "react"
import FieldTypes from "src/pages/dynamic_forms/Types/FieldTypes"
import DynamicFormPaletteTypes from "src/store/DyanmicFormPalette/types"
import TrashCan from "src/pages/dynamic_forms/Utils/TrashCan/TrashCan"
import paletteEngine from "src/pages/dynamic_forms/Utils/paletteEngine"
import { OverlayTrigger } from "react-bootstrap"
import mobileFriendlyWarning from "src/pages/dynamic_forms/Utils/MobileFriendlyWarning/MobileFriendlyWarning"
import reoccuringText from "src/pages/dynamic_forms/Utils/ReoccuringText"
import "./YesOrNoField.css"
import "../../DynamicForm.css"
interface Props {
    manageParentState: Function
    handleChange: Function
    field: FieldTypes
    row: number
    col: number
    formManagerField?: boolean
    configField?: boolean
    templateField?: boolean
    remove: Function
    palette: Array<DynamicFormPaletteTypes>
    readOnly?: boolean
}

function YesOrNoField(props: Props) {

    // console.log("df_FieldYesOrNoField props", props)

    const field = props.field
    const name = field.Name || "Text"
    const templateField = props.templateField
    const formManagerField = props.formManagerField
    const configField = props.configField
    const fieldType = templateField ? "TemplateField" : formManagerField ? "FormMangerField" : configField ? "ConfigField" : "Field"
    const checked = (field.Value && field.Value.toString().toLowerCase().startsWith("t")) ? true : false

    return (
        <div className={`DynamicForm${fieldType} DynamicYesOrNo${fieldType}`} style={{ backgroundColor: `${paletteEngine.getPaletteColor("fieldBackgroundColor")}` }}>
            <div className="DynamicFormFieldHeader">
                {!formManagerField && <div className="DynamicFormFieldHeaderLeft">
                    <p style={{ color: `${paletteEngine.getPaletteColor("headerTextColor")}` }}>{name}</p>
                    {field.Required && !field.Value && <span className="material-icons" style={{ color: `${paletteEngine.getPaletteColor("requiredFieldAsteriskColor")}` }}>*</span>}
                </div>}
                <div className="DynamicFormFieldHeaderRight">
                    {templateField && <div className="DynamicFormFieldHeaderRightSettings">
                        <div className="DynamicFormFieldHeaderRightSettingsMultiColumnarWarning">
                            {props.col > 0 &&
                                <OverlayTrigger placement="right" overlay={mobileFriendlyWarning("Rows with multiple columns", reoccuringText.multipleColumnInRowWarningText)}>
                                    <span
                                        className="material-icons"
                                        style={{ color: `${paletteEngine.getPaletteColor("editorConfigMultiColumnsWarningIconColor")}` }}>
                                        priority_high
                                    </span>
                                </OverlayTrigger>}
                        </div>
                        <span className="material-icons DynamicFormFieldHeaderRightSettingsGear"
                            style={{ color: `${paletteEngine.getPaletteColor("editorConfigGearColor")}` }}
                            onClick={() => props.manageParentState([{ key: "configTarget", value: { row: props.row, col: props.col } }])}>
                            settings
                        </span>
                        <TrashCan clickCallback={() => props.remove(field.Type, props.row, props.col, true)} color={`${paletteEngine.getPaletteColor("editorTrashBinColor")}`} />
                    </div>}
                </div>
            </div>
            <div className="DynamicFormFieldBody">
                <div className="DynamicFormFieldBodyYesOrNo">
                    <div className="DynamicFormFieldBodyYesOrNoItem"
                        style={
                            {
                                outline: `2px solid ${checked && field.Value ?
                                    `${paletteEngine.getPaletteColor("yesNoSelectedOutlineColor")}` :
                                    `${paletteEngine.getPaletteColor("yesNoNotSelectedOutlineColor")}`}`,
                                backgroundColor: `${paletteEngine.getPaletteColor("fieldInputBackgroundColor")}`,
                                color: `${paletteEngine.getPaletteColor("fieldInputTextColor")}`
                            }
                        }
                        onClick={() => {
                            props.manageParentState([{ key: "target", value: { row: props.row, col: props.col, key: "Value" } }])
                            props.handleChange({ target: { value: "true" } })
                        }}>
                        <p>Yes</p>
                    </div>
                    <div className="DynamicFormFieldBodyYesOrNoPipe"></div>
                    <div className="DynamicFormFieldBodyYesOrNoItem"
                        style={
                            {
                                outline: `2px solid ${!checked && field.Value ?
                                    `${paletteEngine.getPaletteColor("yesNoSelectedOutlineColor")}` :
                                    `${paletteEngine.getPaletteColor("yesNoNotSelectedOutlineColor")}`}`,
                                backgroundColor: `${paletteEngine.getPaletteColor("fieldInputBackgroundColor")}`,
                                color: `${paletteEngine.getPaletteColor("fieldInputTextColor")}`
                            }
                        } onClick={() => {
                            props.manageParentState([{ key: "target", value: { row: props.row, col: props.col, key: "Value" } }])
                            props.handleChange({ target: { value: "false" } })
                        }}>
                        <p>No</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default YesOrNoField